// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { PartyCredentialRequirement } from '@daml.js/utility-credential-v0/lib/Utility/Credential/V0/Credential';
import { ProviderConfiguration } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Configuration/Provider';
import {
  ProviderService,
  ProviderService_CreateProviderConfiguration_Result,
} from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Service/Provider';
import { ContractId } from '@daml/types';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';

const useArchiveAndCreateProviderConfiguration: () => UseMutationResult<
  ProviderService_CreateProviderConfiguration_Result,
  string,
  {
    providerServiceCid: ContractId<ProviderService>;
    providerConfigurationCid: ContractId<ProviderConfiguration>;
    holderRequirements: PartyCredentialRequirement[];
    registrarRequirements: PartyCredentialRequirement[];
  }
> = () => {
  const ledgerApi = useLedgerApiClient();

  return useMutation({
    mutationKey: ['archiveAndCreateProviderConfiguraiton', ledgerApi],
    mutationFn: async ({
      providerServiceCid,
      providerConfigurationCid,
      holderRequirements,
      registrarRequirements,
    }) => {
      return ledgerApi.archiveAndCreateRegistryProviderConfiguration(
        providerServiceCid,
        providerConfigurationCid,
        holderRequirements,
        registrarRequirements,
      );
    },
  });
};

export default useArchiveAndCreateProviderConfiguration;
